<template>
  <div class="teacher-layout d-flex flex-column min-vh-100">
    <!-- Top Navbar -->
    <nav class="navbar navbar-expand-lg navbar-dark app-navbar shadow-sm">
      <div class="container-fluid px-4">
        <div class="d-flex align-items-center gap-2">
          <div class="brand-icon">
            <i class="bi bi-mortarboard-fill"></i>
          </div>
          <span class="navbar-brand fw-bold mb-0">LearnBridge</span>
        </div>

        <div class="d-flex align-items-center">
          <div class="teacher-chip text-white me-3 d-none d-sm-flex align-items-center">
            <i class="bi bi-person-circle me-2"></i>
            <span>Teacher</span>
          </div>

          <button
            @click="logout"
            class="btn btn-light btn-sm logout-btn"
            title="Logout"
          >
            <i class="bi bi-box-arrow-right me-1"></i>
            <span class="d-none d-sm-inline">Logout</span>
          </button>
        </div>
      </div>
    </nav>

    <div class="layout-body flex-grow-1 d-flex">
      <!-- Sidebar -->
      <aside class="teacher-sidebar d-flex flex-column">
        <div class="sidebar-header">
          <div class="sidebar-title">Teacher Menu</div>
          <div class="sidebar-subtitle">Manage learning content</div>
        </div>

        <ul class="nav flex-column sidebar-nav px-3 py-3 gap-2">
          <li class="nav-item">
            <router-link
              :to="{ name: 'teacherDashboard' }"
              active-class="active"
              class="nav-link sidebar-link"
            >
              <i class="bi bi-speedometer2"></i>
              <span>Dashboard</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="{ name: 'questions' }"
              active-class="active"
              class="nav-link sidebar-link"
            >
              <i class="bi bi-question-circle"></i>
              <span>Questions</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="{ name: 'create-assessment' }"
              active-class="active"
              class="nav-link sidebar-link"
            >
              <i class="bi bi-ui-checks-grid"></i>
              <span>Test Builder</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              :to="{ name: 'groups' }"
              active-class="active"
              class="nav-link sidebar-link"
            >
              <i class="bi bi-people"></i>
              <span>Groups</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              to="/practice-papers"
              active-class="active"
              class="nav-link sidebar-link"
            >
              <i class="bi bi-file-earmark-pdf"></i>
              <span>Practice Papers</span>
            </router-link>
          </li>
        </ul>

        <div class="sidebar-footer mt-auto px-3 pb-4">
          <div class="help-card">
            <i class="bi bi-lightbulb-fill"></i>
            <div>
              <div class="fw-semibold">Tip</div>
              <small>Create tests from your question bank.</small>
            </div>
          </div>
        </div>
      </aside>

      <!-- Main Content -->
      <main class="main-content flex-grow-1">
        <div class="container-fluid">
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "TeacherLayout",

  methods: {
    async logout() {
      try {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("user_role");

        delete axios.defaults.headers.common["Authorization"];

        await Swal.fire({
          icon: "success",
          title: "Logged out",
          text: "You have been successfully logged out.",
          confirmButtonText: "OK",
        });

        this.$router.push("/");
      } catch (error) {
        console.error("Logout error:", error);

        Swal.fire({
          icon: "error",
          title: "Logout failed",
          text: "An error occurred during logout. Please try again.",
        });
      }
    },
  },
};
</script>

<style scoped>
.teacher-layout {
  background: #f4f7fb;
}

/* Top navbar */
.app-navbar {
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  min-height: 64px;
}

.navbar-brand {
  letter-spacing: 0.2px;
}

.brand-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}

.teacher-chip {
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  padding: 0.35rem 0.75rem;
  font-size: 0.9rem;
}

.logout-btn {
  border-radius: 999px;
  font-weight: 600;
  color: #2563eb;
  border: none;
}

.logout-btn:hover {
  background: #eef2ff;
  color: #1d4ed8;
}

/* Body */
.layout-body {
  background: #f4f7fb;
}

/* Sidebar */
.teacher-sidebar {
  width: 260px;
  min-height: calc(100vh - 64px);
  background: #ffffff;
  border-right: 1px solid #e5e7eb;
  box-shadow: 4px 0 18px rgba(15, 23, 42, 0.05);
}

.sidebar-header {
  padding: 1.35rem 1.25rem 0.8rem;
  border-bottom: 1px solid #eef2f7;
}

.sidebar-title {
  font-size: 0.95rem;
  font-weight: 800;
  color: #111827;
}

.sidebar-subtitle {
  font-size: 0.78rem;
  color: #6b7280;
  margin-top: 0.15rem;
}

.sidebar-nav {
  margin: 0;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #475569;
  font-weight: 700;
  border-radius: 14px;
  padding: 0.78rem 0.9rem;
  transition: all 0.2s ease;
  position: relative;
}

.sidebar-link i {
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
}

.sidebar-link:hover {
  background: #f1f5ff;
  color: #4f46e5;
  transform: translateX(2px);
}

.sidebar-link.active {
  background: linear-gradient(135deg, #eef2ff, #e0e7ff);
  color: #4338ca !important;
  box-shadow: inset 3px 0 0 #4f46e5;
}

.sidebar-link.active i {
  color: #4f46e5;
}

.sidebar-footer {
  border-top: 1px solid #eef2f7;
  padding-top: 1rem;
}

.help-card {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 0.85rem;
  color: #475569;
}

.help-card i {
  color: #f59e0b;
  font-size: 1.1rem;
}

.help-card small {
  color: #64748b;
}

/* Main content */
.main-content {
  padding: 1.5rem;
  min-width: 0;
}

/* Mobile */
@media (max-width: 992px) {
  .layout-body {
    flex-direction: column;
  }

  .teacher-sidebar {
    width: 100%;
    min-height: auto;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }

  .sidebar-header,
  .sidebar-footer {
    display: none;
  }

  .sidebar-nav {
    flex-direction: row !important;
    overflow-x: auto;
    white-space: nowrap;
    padding: 0.75rem !important;
  }

  .sidebar-nav .nav-item {
    flex: 0 0 auto;
  }

  .sidebar-link {
    padding: 0.65rem 0.85rem;
  }

  .sidebar-link:hover {
    transform: none;
  }

  .main-content {
    padding: 1rem;
  }
}

@media (max-width: 576px) {
  .container-fluid {
    padding-left: 0;
    padding-right: 0;
  }

  .navbar .container-fluid {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .navbar-brand {
    font-size: 1rem;
  }

  .brand-icon {
    width: 34px;
    height: 34px;
    font-size: 1rem;
  }
}
</style>